const GettingThere = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M6.25049 11.25L6.25049 8.8015C6.25049 8.76994 6.26832 8.74108 6.29655 8.72697L9.75929 6.9956C9.8701 6.94019 10.0005 7.02078 10.0005 7.14467V12.61C10.0005 12.9256 10.1788 13.2142 10.4611 13.3553L12.4011 14.3253C12.4656 14.3576 12.5179 14.4099 12.5502 14.4744L14.3755 18.125"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M6.25049 18.125L9.37549 15"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M11.8755 7.5L14.3755 10"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M11.563 3.4375C11.563 4.30044 10.8634 5 10.0005 5C9.13754 5 8.43799 4.30044 8.43799 3.4375C8.43799 2.57456 9.13754 1.875 10.0005 1.875C10.8634 1.875 11.563 2.57456 11.563 3.4375Z"
      stroke="#444444"
      strokeWidth="1.25"
    />
  </svg>
);

export default GettingThere;
